import { Component, inject } from '@angular/core';
import { HolidayService } from '../proxy/general/controllers';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  HolidayCreateDto,
  HolidayDto,
  HolidayExcelDownloadDto,
  HolidayUpdateDto,
} from '../proxy/general/dtos/holiday';
import { HOLIDAY_CONFIG, HOLIDAY_FIELDS } from './holiday.config';
import { BaseCrudComponent, CrudPage, GenericForm } from '@zendra/shared';

@Component({
  selector: 'app-holiday',
  imports: [
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, HolidayService, ConfirmationService],
  templateUrl: './holiday.html',
  styleUrl: './holiday.scss',
})
export class Holiday extends BaseCrudComponent<
  HolidayDto,
  HolidayCreateDto,
  HolidayUpdateDto,
  HolidayExcelDownloadDto
> {
  service = inject(HolidayService);
  config = HOLIDAY_CONFIG;
  fields = HOLIDAY_FIELDS;

  protected prepareUpdateDto(data: any, selected: HolidayDto): HolidayUpdateDto {
    return {
      name: data.name,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'Holiday';
  }
}
